import { TweenLite, Power1, TweenMax } from 'gsap';

const handleComplete = target =>
  TweenLite.set(target, {
    clearProps: 'opacity, autoAlpha',
  });
/**
 * What is a node? It is a DOM element.
 * ex: ref={(node) => {
 *        this.node = node
 *        handleAnimation(node)
 *     }}
 * GSAP doesn't care when or where you call it. It only cares about
 * which DOM elements are animating and their before and after
 * CSS properties.
 */
export const handleEnterAnimation = node => {
  if (!node) return;
  // Cancel existing animations
  TweenMax.killTweensOf(node);
  // Set element initial styles
  TweenLite.set(node, {
    autoAlpha: 0,
    opacity: 0,
    ease: Power1.easeIn,
  });
  // Animate element
  TweenLite.to(node, 0.8, {
    autoAlpha: 1,
    opacity: 1,
    onComplete: handleComplete, // Fire this when animation finishes
    onCompleteParams: [node],
  });
};
export const handleExitAnimation = node => {
  if (!node) return;
  // Cancel existing animations
  TweenMax.killTweensOf(node);
  // Animate element
  TweenLite.to(node, 0.5, {
    opacity: 0,
    autoAlpha: 0,
    ease: Power1.easeIn,
  });
};
